import styled from 'styled-components/macro';

export const AllArticlesPage = styled.div`
  margin: 2.5rem;

  .search-faq-row {
    margin-bottom: 1rem;
  }
`;

export const CategoryRow = styled.div`
  margin-top: 1.5rem;
  color: #1a285c;
  border-bottom: 1px solid #efefef;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.9rem;
  font-family: lato, sans-serif;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const ArticleLink = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  cursor: pointer;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;

  &::before {
    content: '-';
    margin-right: 5px;
    margin-left: 20px;
  }

  &:hover {
    font-weight: bold;
    color: #1a285c;
  }
`;
